import loadComponents from "./components";
import loadBlocks from "./block";
import { Plugin } from "grapesjs";
import {
  PluginOptions,
  RequiredPluginOptions,
} from "../../../../../types/types";

const plugin: Plugin<PluginOptions> = (editor, opts = {}) => {
  const options: RequiredPluginOptions = {
    id: "reliable-navbar",
    label: "Reliable Navbar",
    block: {},
    style: "",
    styleAdditional: "",
    classPrefix: "reliable-navbar",
    ...opts,
  };

  loadBlocks(editor, options);
  loadComponents(editor, options);
};

export default plugin;
